module.exports = __webpack_public_path__ + "static/power-img1-3-00fd95b5bc1378b59777fce5cf647de2.png";